import React from 'react'
import { Grid } from 'semantic-ui-react'

const PageColumn = ({children}) => (
  <Grid.Column style={{marginLeft: '1rem', marginRight: '1rem'}}>
    {children}
  </Grid.Column>  
)

export default PageColumn


// WEBPACK FOOTER //
// ./src/components/PageColumn.js